// extracted by mini-css-extract-plugin
export var attachment = "_pd-a";
export var emailContainer = "_pd-4";
export var emailContentPaddedContainer = "_pd-b";
export var emailHeader = "_pd-6";
export var emailIframe = "_pd-3";
export var emailInfoIcon = "_pd-9";
export var emailShortenedSummary = "_pd-e";
export var infoDropdown = "_pd-0";
export var infoRowBoundedContent = "_pd-d";
export var internal = "_pd-5";
export var merchant = "_pd-8";
export var messageInputContainer = "_pd-h";
export var normal = "_pd-7";
export var replyCard = "_pd-f";
export var subtleButton = "_pd-1";
export var subtleButtonIconContainer = "_pd-2";
export var toggleViewRepliesButton = "_pd-c";
export var wrappingText = "_pd-g";